export default __webpack_public_path__ + "static/media/donation-phone-org.6184b46f.png";